import { render, staticRenderFns } from "./SBJDataOW.vue?vue&type=template&id=25db225a&scoped=true&"
import script from "./SBJDataOW.vue?vue&type=script&lang=js&"
export * from "./SBJDataOW.vue?vue&type=script&lang=js&"
import style0 from "./SBJDataOW.vue?vue&type=style&index=0&id=25db225a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db225a",
  null
  
)

export default component.exports